// Gravity input focus
(function () {
    'use strict';

    let inputs = document.querySelectorAll('.inline_wrap input, .inline_wrap textarea, .gfield input, .gfield textarea');

    function onFocus(e) {
        let closeDivs = e.target.closest('div');
        let closeLis = e.target.closest('li');

        if (closeDivs) {
            closeDivs.classList.add('active');
        }
        if (closeLis) {
            closeLis.classList.add('active');
        }
    }

    function onBlur(e) {
        if (e.target.value === '') {
            let closeDivs = e.target.closest('div');
            let closeLis = e.target.closest('li');

            if (closeDivs) {
                closeDivs.classList.remove('active');
            }
            if (closeLis) {
                closeLis.classList.remove('active');
            }
        }
    }

    for (let i = 0, l = inputs.length; i < l; i++) {
        inputs[i].addEventListener('focus', onFocus);
        inputs[i].addEventListener('blur', onBlur);
    }
})();

/**
 * addParentClass
 * @param {string} selector 
 * @param {string} myClass 
 */
function addParentClass(selector, myClass) {
    let elements = document.querySelectorAll(selector);

    for (let i = 0; i < elements.length; i++) {
        elements[i].parentNode.classList.add(myClass);
    }
}

addParentClass('.ginput_container_select', 'tisaselect');